module.exports = __webpack_public_path__ + "static/media/pickup1.16b22056.png";